import apiFetch from '../apiFetch'

export default function (token, { page, pageSize, orderBy, name, dateFrom, dateTo }) {
  const queryParamsArray = [
    page ? `page=${page}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    orderBy ? `orderBy=${orderBy}` : null,
    name ? `name=${name}` : null,
    dateFrom ? `dateFrom=${dateFrom}` : null,
    dateTo ? `dateTo=${dateTo}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({
    endPoint: `FtpRegister/Search${queryParams}`,
    method: 'GET',
    body: null,
    token: token
  })
}
